import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  CreateVisaInfo,
  FindManyVisaInfo,
  FindOne,
  PaginateResult,
  UpdateVisaInfo,
  VisaInfo,
  VISA_REQUIREMENT,
} from '@univacity/shared/types';

import { Observable } from 'rxjs';
import { Configuration } from '../config/configuration';

@Injectable({
  providedIn: 'root',
})
export class VisaInfoService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: Configuration) {
    this.baseUrl = this.config.apiMainUrl + '/visa/info';
  }

  create(visaInfo: CreateVisaInfo): Observable<VisaInfo> {
    return this.http.post<VisaInfo>(this.baseUrl, visaInfo);
  }

  find(query: FindManyVisaInfo = {}): Observable<PaginateResult<VisaInfo>> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<PaginateResult<VisaInfo>>(this.baseUrl, { params });
  }

  findOne(id: string, query: FindOne = {}): Observable<VisaInfo> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<VisaInfo>(`${this.baseUrl}/${id}`, { params });
  }

  findOnByCode(
    citizen: string,
    destination: string,
    query: FindOne = {}
  ): Observable<VisaInfo> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<VisaInfo>(
      `${this.baseUrl}/citizen/${citizen}/destination/${destination}`,
      { params }
    );
  }

  getVisaRequirement(
    country: string,
    citizen: string
  ): Observable<{ requirement: VISA_REQUIREMENT }> {
    return this.http.get<{ requirement: VISA_REQUIREMENT }>(
      `${this.baseUrl}/requirement/${country}/${citizen}`
    );
  }

  count(queryParams?: FindManyVisaInfo): Observable<number> {
    const params = new HttpParams({
      fromObject: queryParams as Params,
    });

    return this.http.get<number>(`${this.baseUrl}/count`, {
      params,
    });
  }

  update(countryCode: string, visaInfo: UpdateVisaInfo): Observable<VisaInfo> {
    return this.http.patch<VisaInfo>(
      `${this.baseUrl}/${countryCode}`,
      visaInfo
    );
  }

  delete(code: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${code}`);
  }
}
